import {ObjectId, ObjectType} from '../object.model';
import {UserId} from '../user';

export enum Permission {
  CAN_CHANGE_HUB = 'can_change_hub',
  CAN_CHANGE_OWNER = 'can_change_owner',
  CAN_CHAT = 'can_chat',
  CAN_CONFIGURE = 'can_configure',
  CAN_CREATE = 'can_create',
  CAN_CREATE_DEVICES = 'can_add_devices',
  CAN_CREATE_TILES = 'can_add_tiles',
  CAN_DELETE = 'can_delete',
  CAN_DELETE_DEVICES = 'can_delete_devices',
  CAN_DELETE_TILES = 'can_delete_tiles',
  CAN_DISCOVER = 'can_discover',
  CAN_DISCOVER_DEVICES = 'can_discover_devices',
  CAN_DISCOVER_POINTS = 'can_discover_points',
  CAN_EDIT_SCHEDULES = 'can_edit_schedules',
  CAN_QUERY_USERS = 'can_query_users',
  CAN_READ_VALUES = 'can_read_values',
  CAN_RESPOND = 'can_respond',
  CAN_SHARE = 'can_share',
  CAN_WRITE_VALUES = 'can_write_values'
}

export interface PermissionResponse {
  UserID: UserId;
  ObjectID: ObjectId;
  ObjectType: ObjectType;
  Results: {
    Permission: Permission;
    Allowed: boolean;
  }[];
}

export interface PermissionQueryParams {
  UserID: UserId;
  Permissions: Permission[];
  ObjectID?: ObjectId;
  ObjectType?: ObjectType;
}
